export default __webpack_public_path__ + "static/fv-nr-3-220937bc6e23a5913b3679ee0914fddd.avif";